import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { DynamicIcon } from 'src/components';
import {
  configSurfaceToggleGroupSx,
  configSurfaceToggleSx,
} from 'src/pages/Settings/memberships/styles';
import type { ConfigSurface } from 'src/pages/Settings/memberships/types';

const SURFACE_ICON_SIZE_PX = 16;

const SURFACES: { value: ConfigSurface; label: string; icon: string }[] = [
  { value: 'memberships', label: 'Membership Options', icon: 'list-checks' },
  { value: 'landingPage', label: 'Landing Page', icon: 'layout-dashboard' },
];

type ConfigSurfaceToggleProps = {
  value: ConfigSurface;
  onChange: (surface: ConfigSurface) => void;
};

export const ConfigSurfaceToggle = ({ value, onChange }: ConfigSurfaceToggleProps) => (
  <ToggleButtonGroup
    exclusive
    fullWidth
    size="small"
    value={value}
    onChange={(_, next: ConfigSurface | null) => {
      if (next) {
        onChange(next);
      }
    }}
    aria-label="Configuration page"
    sx={configSurfaceToggleGroupSx}
  >
    {SURFACES.map((surface) => (
      <ToggleButton key={surface.value} value={surface.value} sx={configSurfaceToggleSx}>
        <DynamicIcon name={surface.icon} library="lucide" size={SURFACE_ICON_SIZE_PX} />
        {surface.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);
